import Paragraph from 'components/Paragraph'
import Image from 'components/Image'

import Styled from './styled'

export default function CardService({ title, image, eager = false }) {
  return (
    <Styled className="card-service">
      <div className="image-block">
        <Image
          src={image}
          alt=""
          width={192}
          height={192}
          imgixWidth={192}
          lazyload={!eager}
        />
      </div>

      <div className="info-block">
        <div className="title-block">
          <Paragraph className="text-title">{title}</Paragraph>
        </div>
      </div>
    </Styled>
  )
}
